import { Injectable } from '@angular/core';
import { SiteLanguageStoreService } from '@motivforce/mx-library-angular';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocaleStoreService {
  private readonly _currentLocaleCode = new BehaviorSubject<string | null>(null);

  readonly currentLocaleCode$ = this._currentLocaleCode.asObservable();

  constructor(private siteLanguageStore: SiteLanguageStoreService) {
    this.siteLanguageStore.language$.subscribe((language) => {
      this._currentLocaleCode.next(language || null);
    });
  }

  get currentLocaleCode(): string | null {
    return this._currentLocaleCode.value;
  }
}
